import { ConfigProvider } from 'antd';
import { EXTERNAL_FORM_DEFAULTS, externalFormFontFamily } from '@/features/externalForm/constants';

export const FormTheme = ({ config = EXTERNAL_FORM_DEFAULTS, children }) => {
  const colorPrimary = config.primaryColor || EXTERNAL_FORM_DEFAULTS.primaryColor;
  const colorText = config.textColor || EXTERNAL_FORM_DEFAULTS.textColor;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary,
          colorText,
          colorTextSecondary: '#4b5565',
          colorError: '#c4291c',
          colorBorder: '#dfe4ee',
          colorBorderSecondary: '#e4e8f0',
          fontFamily: externalFormFontFamily(config.fontFamily || EXTERNAL_FORM_DEFAULTS.fontFamily),
          borderRadius: 10,
          controlHeight: 46,
          controlHeightLG: 48,
        },
        components: {
          Input: { colorBgContainer: '#f7f8fb', activeBg: '#ffffff' },
          Select: { colorBgContainer: '#f7f8fb' },
          Form: {
            labelFontSize: 14,
            labelHeight: 22,
            verticalLabelPadding: '0 0 4px',
            itemMarginBottom: 12,
          },
          Button: { fontWeight: 600 },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
